<template>
    <div v-if="isMobile" id="myNav" class="overlay overlay-without-header">
        <form autocomplete="off" novalidate method="POST" class="mainForm" @submit.prevent="submit" ref="mobile_form">
            <a href="javascript:void(0)" class="closebtn" onclick="closeNav()">&times;</a>
                <div class="overlay-content">
                    <div class="col-lg-4 col-md-12">
                        <div class="sidebar-right">
                            <div class="form-group">
                                <ul class="strong">
                                    <strong class="text-primary">Cosa stai cercando</strong>
                                    <vue-select
                                        :labelcolor="colors.secondary"
                                        :primarycolor="colors.primary"
                                        :options="dropdowns.tipiAzienda"
                                        name="type_id"
                                        trackby="id"
                                        :required="true"
                                        :currentvalue="currentsearch.tipologia"
                                        selectname="tipologia"
                                        :allowEmpty="false"
                                        @onChange="tipologiaChanged"
                                        placeholder="Seleziona tipo agenzia">
                                    </vue-select>
                                </ul>
                            </div>
                            <div class="form-group">
                                <ul class="strong">
                                    <strong class="text-primary">Comune</strong>
                                    <vue-select
                                        :labelcolor="colors.secondary"
                                        :primarycolor="colors.primary"
                                        :options="dropdowns.comuni"
                                        name="citta_id"
                                        trackby="id"
                                        :currentvalue="currentsearch.citta"
                                        selectname="comune"
                                        :allowEmpty="true"
                                        @onChange="comuneChanged"
                                        placeholder="Seleziona comune">
                                    </vue-select>
                                </ul>
                            </div>
                            <div class="form-group">
                                <ul class="strong">
                                    <strong class="text-primary">Azienda</strong>
                                    <vue-select
                                        :labelcolor="colors.secondary"
                                        :primarycolor="colors.primary"
                                        :options="dropdowns.aziende"
                                        name="azienda_id"
                                        :currentvalue="currentsearch.azienda"
                                        trackby="id"
                                        :allowEmpty="true"
                                        selectname="azienda"
                                        @onChange="aziendaChanged"
                                        placeholder="Seleziona azienda">
                                    </vue-select>
                                </ul>
                            </div>
                            <div class="form-group mb-0">
                                <button class="search-button" :disabled="isLoading">
                                    <i class="fas fa-spinner fa-spin" v-if="isLoading"></i>
                                    <span v-else>Cerca</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
        </form>
    </div>
</template>

<script>
    export default {
        props: ['dropdowns', 'currentsearch', 'colors', 'isLoading', 'isMobile'],
        methods: {
            submit(event) {
                this.$emit('submitsearch');
            },
            comuneChanged(event) {
                this.$emit('comunechanged', event);
            },
            tipologiaChanged(event) {
                this.$emit('tipologiachanged', event);
            },
            aziendaChanged(event) {
                this.$emit('aziendachanged', event);
            }
        }
    }
</script>